import { addFileAttachment, addItemAttachment, removeAttachment } from './AttachmentAdapter';
import { getBody, getBodyType, prependBody, setBody, setBodySelectedData } from './BodyAdapter';
import { closeItem } from './CloseAdapter';
import { getConversationId } from './ConversationIdAdapter';
import { addRecipients, getRecipients, setRecipients } from './RecipientsAdapter';
import saveItem from './saveItem';
import { getSelectedData, setSelectedData } from './SelectedDataAdapter';
import { getSubject, setSubject } from './SubjectAdapter';
import { displayMessageForm } from '../CommonAdapters/DisplayMessageFormAdapter';
import { isComposeAddinPinned as isAddinPinned } from '../CommonAdapters/IsAddinPinnedAdapter';
import { getComposeItemId as getItemId } from '../CommonAdapters/ItemIdAdapter';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { addNotificationMessage, removeNotificationMessage, getNotificationMessageIds, } from '../NotificationMessageAdapters/ComposeNotificationMessageAdapter';
export default function createMailComposeAdapter(viewState) {
    return {
        getRecipients: getRecipients(viewState),
        setRecipients: setRecipients(viewState),
        addRecipients: addRecipients(viewState),
        getSubject: getSubject(viewState),
        setSubject: setSubject(viewState),
        getItemId: getItemId(viewState),
        getConversationId: getConversationId(viewState),
        getBody: getBody(viewState),
        setBody: setBody(viewState),
        getBodyType: getBodyType(viewState),
        prependBody: prependBody(viewState),
        getSelectedData: getSelectedData(viewState),
        setSelectedData: setSelectedData(viewState),
        setBodySelectedData: setBodySelectedData(viewState),
        mode: ExtensibilityModeEnum.MessageCompose,
        saveItem: saveItem(viewState),
        addNotificationMessage: addNotificationMessage(viewState),
        removeNotificationMessage: removeNotificationMessage(viewState),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        close: closeItem(viewState),
        displayMessageForm: displayMessageForm,
        addItemAttachment: addItemAttachment(viewState),
        addFileAttachment: addFileAttachment(viewState),
        removeAttachment: removeAttachment(viewState),
        isAddinPinned: isAddinPinned,
    };
}
//# sourceMappingURL=ComposeAdapterCreator.js.map